<template>
  <div id="ContentDetailPage">
    <NavBar/>
    <v-main class="third-bg">
      <div class="container-fluid third-bg py-10">
        <div class="container-md">
          <div class="row">
            <div class="col-md-6 mx-auto">
              <!--              <v-img v-if="pageDetail.MainOriginalFileUrl !== undefined" :src="$replaceHttps(pageDetail.MainOriginalFileUrl)">
                            </v-img>-->
              <zoom-on-hover v-if="pageDetail.MainOriginalFileUrl !== undefined"
                             :img-normal="$replaceHttps(pageDetail.MainOriginalFileUrl)" :scale="1.5"
                             class="rounded-lg"></zoom-on-hover>

            </div>
            <div class="col-12 bg-white p-4" v-html="pageDetail.Description">
            </div>

            <div v-if="pageDetail.ReferralUrl !== null" class="col-12">
              <a :href="pageDetail.ReferralUrl" class="btn primary white--text" target="_blank">
                <i class="fa-duotone fa-arrow-up-right-from-square"></i>
                <span> مرجع</span>
              </a>
            </div>
          </div>
          <div v-if=" lastVisited !== null && lastVisited !== undefined && lastVisited.length > 0"
               class="row ">
            <div class="col-auto mt-15  font-16">
              <div class="border-bottom-gold pb-2 px-5 font-18">
                آخرین مشاهده ها
              </div>
            </div>
            <div
                v-if="showArticle && lastVisited !== null && lastVisited !== undefined && lastVisited.length > 0"
                class="col-12 "
                dir="ltr">
              <carousel
                  :autoplay="true"
                  :dots="false"
                  :items="4"
                  :loop="false"
                  :margin="15"
                  :nav="false"
                  :responsive="{0:{items:1,nav:false},600:{items:2,nav:false}
                      ,900:{items:3,nav:false},1200:{items:4,nav:false}}"
                  class="py-0">
                <div v-for="item in lastVisited" :key="item.ArticleId">
                  <router-link :to="{path:'ContentDetail' , query:{id : item.ArticleId , type: 3}}"
                               class="bg-white rounded-lg d-block">
                    <ContentCard :item="item"/>
                  </router-link>
                </div>
              </carousel>
            </div>
            <div
                v-if="showEvent && lastVisited !== null && lastVisited !== undefined && lastVisited.length > 0"
                class="col-12 "
                dir="ltr">
              <carousel
                  :autoplay="true"
                  :dots="false"
                  :items="4"
                  :loop="false"
                  :margin="15"
                  :nav="false"
                  :responsive="{0:{items:1,nav:false},600:{items:2,nav:false}
                      ,900:{items:3,nav:false},1200:{items:4,nav:false}}"
                  class="py-0">
                <div v-for="item in lastVisited" :key="item.EventId">
                  <router-link :to="{path:'ContentDetail' , query:{id : item.EventId , type: 1}}"
                               class="bg-white rounded-lg d-block">
                    <ContentCard :item="item"/>
                  </router-link>
                </div>
              </carousel>
            </div>
            <div
                v-if="showNews && lastVisited !== null && lastVisited !== undefined && lastVisited.length > 0"
                class="col-12 "
                dir="ltr">
              <carousel
                  :autoplay="true"
                  :dots="false"
                  :items="4"
                  :loop="false"
                  :margin="15"
                  :nav="false"
                  :responsive="{0:{items:1,nav:false},600:{items:2,nav:false}
                      ,900:{items:3,nav:false},1200:{items:4,nav:false}}"
                  class="py-0">
                <div v-for="item in lastVisited" :key="item.NewsItemId">
                  <router-link :to="{path:'ContentDetail' , query:{id : item.NewsItemId , type: 2}}"
                               class="bg-white rounded-lg d-block">
                    <ContentCard :item="item"/>
                  </router-link>
                </div>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </v-main>
    <FooterComponent/>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import ContentCard from "@/Academy/components/ContentCard";
import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";


export default {
  name: "ContentDetail",
  metaInfo () {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.metaKeyword
        },
        { //  set meta
          name: 'description',
          content: this.metaDescription
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.metaDescription,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.metaDescription,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {FooterComponent, NavBar, ContentCard, carousel},
  data: () => ({
    lastVisited: [],
    showLoaderDialog: false,
    pageDetail: {},
    isContentLoaded: false,
    showArticle: false,
    showNews: false,
    showEvent: false,
    metaKeyword: null,
    metaDescription: null,
  }),
  watch: {
    '$route.query.id' () {
      location.reload()
    }
  },
  mounted () {
    this.metaKeyword = this.$keywords;
    this.metaDescription = this.$description;

    if (this.$route.query.type === "1") {
      this.getEventDetail()
      this.showEvent = true
    } else if (this.$route.query.type === "2") {
      this.getNewsDetail()
      this.showNews = true
    } else if (this.$route.query.type === "3") {
      this.articleDetail()
      this.showArticle = true
    }
  },

  methods: {
    getEventDetail () {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/EventDetails?eventId=" + this.$route.query.id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.pageDetail = json.item
            if (this.$getUserData().token !== '') {
              this.lastVisited = json.visitedItems
            }
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    getNewsDetail () {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/NewsDetail?newsId=" + this.$route.query.id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.pageDetail = json.item
            if (this.$getUserData().token !== '') {
              this.lastVisited = json.visitedItems
            }

          })
          .catch(error => console.log('error', error));
    },
    articleDetail () {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/ArticleDetail?articleId=" + this.$route.query.id, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.metaKeyword = json.MetaTagKeywords ?? this.$keywords;
            this.metaDescription = json.MetaTagDescription ?? this.$description;
            this.pageDetail = json.item
            if (this.$getUserData().token !== '') {
              this.lastVisited = json.visitedItems
            }
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>
